export default (state = {}, {date}: any) => {
  return {
    ...state,
    date,
  };
};
